import { render, staticRenderFns } from "./Swinger.vue?vue&type=template&id=6f282b74&scoped=true"
import script from "./Swinger.vue?vue&type=script&lang=ts"
export * from "./Swinger.vue?vue&type=script&lang=ts"
import style0 from "./Swinger.vue?vue&type=style&index=0&id=6f282b74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f282b74",
  null
  
)

export default component.exports